import { checkPageFormatMatching } from "./checkPageFormatMatching";
import {
  MARKER_MATCH_TOLERANCE_METERS,
  MARKER_MATCH_TOLERANCE_PDF_POINTS_FALLBACK,
  ROUTE_ENDPOINT_TOLERANCE_METERS,
  ROUTE_ENDPOINT_TOLERANCE_PDF_POINTS_FALLBACK,
} from "./constants";
import { diffMarkersByType } from "./diffMarkersByType";
import { diffRoutesByType } from "./diffRoutesByType";
import { resolveTolerancePdfPoints } from "./matching";
import { compareTypeEntries } from "./typeEntries";
import type { ComputeVisualDiff } from "./types";

// NOTE: every page's geometry is emitted though the viewer draws page 0; filter here once plans have more than one page.
export const computeVisualDiff: ComputeVisualDiff = ({
  beforePlan,
  afterPlan,
}) => {
  const markersDiff = diffMarkersByType({
    beforePlan,
    afterPlan,
    tolerancePdfPoints: resolveTolerancePdfPoints(
      beforePlan,
      afterPlan,
      MARKER_MATCH_TOLERANCE_METERS,
      MARKER_MATCH_TOLERANCE_PDF_POINTS_FALLBACK,
    ),
  });

  const routesDiff = diffRoutesByType({
    beforePlan,
    afterPlan,
    tolerancePdfPoints: resolveTolerancePdfPoints(
      beforePlan,
      afterPlan,
      ROUTE_ENDPOINT_TOLERANCE_METERS,
      ROUTE_ENDPOINT_TOLERANCE_PDF_POINTS_FALLBACK,
    ),
  });

  const typeEntries = [
    ...markersDiff.typeEntries,
    ...routesDiff.typeEntries,
  ].sort(compareTypeEntries);

  return {
    markersByStatus: markersDiff.markersByStatus,
    routesByStatus: routesDiff.routesByStatus,
    markersByType: markersDiff.markersByType,
    routesByType: routesDiff.routesByType,
    typeEntries,
    isPageFormatMatching: checkPageFormatMatching(beforePlan, afterPlan),
  };
};
